import { render, staticRenderFns } from "./AutosizeTextArea.vue?vue&type=template&id=31d4d733&scoped=true&"
import script from "./AutosizeTextArea.vue?vue&type=script&lang=js&"
export * from "./AutosizeTextArea.vue?vue&type=script&lang=js&"
import style0 from "./AutosizeTextArea.vue?vue&type=style&index=0&id=31d4d733&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d4d733",
  null
  
)

export default component.exports